module.exports = __webpack_public_path__ + "img/success.1dc3d326.svg";